<template>
    <div>
        <div class="modal fade bd-example-modal-sm" :id="className" tabindex="-1"
             role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-sm" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" >{{ company }} x Charge</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p class="noResult">
                            <slot></slot>
                        </p>
                        <button type="button" class="btn btn-dark btn-block mt-1" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <button data-toggle="modal" :data-target="targetName" class="btn btn-primary mt-4">More details</button>
    </div>
</template>

<script>
  export default {
    name: 'PerkDetails',
    props: {
      company: {
        type: String,
        required: true
      }
    },
    computed: {
      className(){
        return this.company + "Modal";
      },
      targetName(){
        return "#" + this.className;
      }
    }
  };
</script>

<style scoped>

</style>
